import { Signage } from '@kcd/design-system';

import WishProductForm from './WishProductForm';

import SearchIcon from '~/assets/icons/ic__system__search__outline.svg';

function EmptyProductSearch() {
  return (
    <div className="px-20">
      <Signage
        image={() => <SearchIcon />}
        marginTop={64}
        title="검색된 상품이 없습니다"
        description={`찾으시는 상품을 남겨 주시면\n빠르게 입점하겠습니다`}
        className="flex-none"
      />
      <WishProductForm />
    </div>
  );
}

export default EmptyProductSearch;
